var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout layout--default"},[_c('div',{staticClass:"site-content u-smooth-load--visible"},[_c('Messages',{attrs:{"context":_vm.$CONTEXTS.root}}),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }